import ZkOperatorLog from './src/main'
ZkOperatorLog.install = function (Vue) {
  Vue.component(ZkOperatorLog.name, ZkOperatorLog)
}
export default ZkOperatorLog



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/operatorLog/index.js